import type { MatrixAnchors } from '@nest-recruit/shared';

// The empty matrix's one-click start (JOB-13): four qualities most roles hire on, each already
// saying what a 1, a 3 and a 5 look like, so a first-time user sees a finished example to edit
// rather than a blank grid.

export interface StarterQuality {
  readonly label: string;
  readonly anchors: MatrixAnchors;
}

export const STARTER_QUALITIES: readonly StarterQuality[] = [
  {
    label: 'Trainability',
    anchors: {
      '1': 'Repeats the same mistake after being shown',
      '3': 'Learns with some help and a few reminders',
      '5': 'Picks up something new quickly, on their own',
    },
  },
  {
    label: 'Communication',
    anchors: {
      '1': 'Hard to follow; misses the point of the question',
      '3': 'Clear on familiar topics; rambles on harder ones',
      '5': 'Clear and brief, and checks they were understood',
    },
  },
  {
    label: 'Problem solving',
    anchors: {
      '1': 'Gets stuck without step-by-step help',
      '3': 'Solves familiar problems; needs a nudge on new ones',
      '5': 'Breaks a new problem down and solves it alone',
    },
  },
  {
    label: 'Attitude',
    anchors: {
      '1': 'Blames others; shows little interest in the work',
      '3': 'Positive and willing when things go smoothly',
      '5': 'Owns mistakes and stays positive under pressure',
    },
  },
];
